export default __webpack_public_path__ + "media/images/handshake-055fc5d5c465c73b93e9d74285e13fae.jpg";